import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { VagaUnidade } from './vaga-unidade.model';
import { AbVagaUnidade } from 'app/abstract/full-pages/vaga/vaga-unidade.abstract';


@Injectable({ providedIn: 'root' })
export class VagaUnidadeService extends AbVagaUnidade {

  constructor(http: HttpClient) {
    super(http);
  }

  public getVagaUnidade() {
    return this.get("vagaunidades/all/");
  }

  public getAllVagaUnidade(filter: AppFilter): Observable<any> {
    return this.get(`vagaunidades/filter/${filter.encode()}`);
  }

  public saveVagaUnidade(vagaUnidade: VagaUnidade): Observable<any> {
    return this.save("vagaunidades/", vagaUnidade);
  }

  public deletar(id: number) {
    return this.delete("vagaunidades/", id);
  }

  public getVagasByUnidade(filter: AppFilter): Observable<any> {
    return this.get(`vagas/vagas_unidade/${filter.encode()}`);
  }


}